module.exports = __webpack_public_path__ + "img/imgZXGH(11).2c9d5285.png";